import { IAvailableWindows } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/IMyShipments'

export const EXPRESS_SLA_ID = 'Despacho Express'

export interface IAvailableWindowWithExpress extends IAvailableWindows {
  expressAmount?: number
  expressExceed?: boolean
}
